import { PluginKey, type PluginsState } from '@databases/plugins';

import { type ModeConfig } from '../types';

import { buildDefaultSelectionFeatures } from './build-default-selection-features';
import { createBaseModeConfig } from './create-base-mode-config';

const pluginsState: PluginsState = {
  [PluginKey.CELL_SELECTION]: () => true,
  [PluginKey.COMMENTS]: () => true,
  [PluginKey.CONTEXT_MENU]: () => true,
  [PluginKey.EDIT_CONTENT]: () => true,
  [PluginKey.QUICK_CALCULATIONS]: () => true,
  [PluginKey.VIEW_SETTINGS_ACTIONS]: () => true,
};

export function createDefaultModeConfig(): ModeConfig {
  return createBaseModeConfig({
    plugins: pluginsState,
    buildSelectionFeatures: buildDefaultSelectionFeatures,
  });
}
